import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "../src/css/custom.css"
import "../src/css/responsive.css"


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);